import React, { Component } from "react";
import PropTypes from "prop-types";

import { MdClose, MdCheck } from "react-icons/md";

class BaseButton extends Component {
  render() {
    const { children, ...buttonProps } = this.props;

    return <button {...buttonProps}>{children}</button>;
  }
}

export class Button extends Component {
  render() {
    const { type, children, ...buttonProps } = this.props;

    return (
      <BaseButton className="button" {...buttonProps}>
        <span className="button__text">{children}</span>
      </BaseButton>
    );
  }
}

export class ResetButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  /**
   * Prevent default on click, then call
   * passed event handler.
   *
   * @author Sam Sehnert <sam@customd.com>
   *
   * @param  {Event}   e          An event object.
   * @param  {mixed}   rest       Any further arguments passed.
   *
   * @return {void}
   */
  onClick(e, ...rest) {
    const { onClick } = this.props;

    e.preventDefault();

    if (onClick) onClick(e, ...rest);
  }

  render() {
    const { type, children, onClick, ...buttonProps } = this.props;

    return (
      <BaseButton
        className="btn_sec mr--24"
        onClick={this.onClick}
        type="reset"
        {...buttonProps}
      >
        {children}
      </BaseButton>
    );
  }
}

export class SaveButton extends Component {
  static propTypes = {
    variant: PropTypes.oneOf(["", "saving", "success", "error"]),
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    onTryAgain: PropTypes.func,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
  };

  static defaultProps = {
    variant: "",
    disabled: false,
    errorMessage: "",
  };

  render() {
    const {
      variant,
      onClick,
      onTryAgain,
      children,
      errorMessage,
      disabled,
      ...buttonProps
    } = this.props;

    let buttonSaveClass = "";
    const buttonTryAgainClass =
      typeof onTryAgain === "function" ? " hide" : " hide";
    let isDisabled = false;

    switch (variant) {
      case "saving":
        buttonSaveClass = " is-saving";
        isDisabled = true;
        break;

      case "success":
        buttonSaveClass = " is-saving is-success";
        break;

      case "error":
        buttonSaveClass = " is-saving is-error";
        break;
      default:
        buttonSaveClass = "";
    }

    return (
      <div className="relative">
        <BaseButton
          className={`save-button${buttonSaveClass}`}
          type="submit"
          onClick={(e) => {
            // If the button is in an error state, close the tooltip rather than re-submitting.
            typeof onTryAgain === "function" &&
            buttonSaveClass.trim() === "is-saving is-error"
              ? onTryAgain(e)
              : onClick(e);
          }}
          {...buttonProps}
          disabled={isDisabled || disabled}
        >
          <span className="save-button__text">{children}</span>
          <div className="save-button__validation">
            <div className="spinner" />
            <MdCheck className="save-button__check" size={18} />
            <MdClose className="save-button__error" size={18} />
          </div>
        </BaseButton>
        <div className="save-button__error-text input__error">
          {errorMessage || "Something went wrong. Failed to save changes."}
          <button
            className={`save-button__try-again btn__solid--white${buttonTryAgainClass}`}
            onClick={onTryAgain}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }
}

export default Button;
